import React, { useState, useEffect } from 'react';
import { useNavigate ,useSearchParams} from "react-router-dom";

function NewPasswordCom() {
    let navigate = useNavigate()
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [newPassError, setNewPassError] = useState("");
    const [confirmPassError, setconfirmPassError] = useState("");
    const [email, setEmail] = useState("");

    let SERVER_URL = process.env.REACT_APP_API_URL;

    const [searchParams, setSearchParams] = useSearchParams();
    const values = searchParams.get('verify')
    useEffect(() => {
        const base64EncodedString = values;
        const decodedString =window.atob(base64EncodedString);
   
        setEmail(decodedString)
    }, []);
    const handleNewPasswordChange = (e) => {
        setNewPassword(e.target.value);
        if (newPassword !== "") {
            setNewPassError('');
        } else {
            setNewPassError('Enter your new password')
        }
    };

    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
        if (confirmPassword !== '') {
            setconfirmPassError('');
        } else {
            setconfirmPassError('Enter your confirm password')
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (newPassword === confirmPassword && newPassword !== '' || confirmPassword !== "") {
            const password = newPassword;
            setNewPassword("");
            setConfirmPassword("");
            try {
                if (newPassword === confirmPassword) {
                    const response = await fetch(SERVER_URL + `api/login/change-new-password`, {
                        method: "PUT",
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ email, password }),
                    });
                    if (!response.ok) {
                        const errorData = await response.json();
                        setError(errorData.message);
                    } else {
                        const successData = await response.json();
                        setNewPassword("");
                        setConfirmPassword("");
                        setError(successData.msg);
                        setTimeout(function () {
                            navigate("/login")
                          }, 1000);
                    }
                }else{
                    setError('Password is not match');
                }
            } catch (error) {
                setError(error.message);
            }
        } else {
            if (confirmPassword !== '') {
                setconfirmPassError('');
            } else {
                setconfirmPassError('Enter your confirm password')
            }
            if (newPassword !== "") {
                setNewPassError('');
            } else {
                setNewPassError('Enter your new password')
            }
            setError('Password is not match');
        }
    };
    return (
        <>
            <div className="login_container">
                <div className="left_panel_login">
                    <div className="loginbg_blk">
                        <img src="assets/images/login.svg" alt="" />
                    </div>
                </div>
                <div className="right_panel_login">
                    <div className="login_wrapper">
                        <div className="login_blk">
                            <div id="login">

                                <form onSubmit={handleSubmit}>
                                    <div className="login_head">
                                        <div className="logo_blk float-start"><img src="assets/images/qbs_learning.png" /></div>
                                    </div>
                                    <div className="change_pass_wrp">
                                        <h4>Create Your New Password</h4>
                                        <p className="mb25">To Make your account secure, please create a new password to replace the temporary password.</p>
                                    </div>
                                    <div className="formblk mb20">
                                        <label className="form-label">New Password <span className="error_star">* {newPassError && <p className="error_star">{newPassError}</p>}</span></label>
                                        <div className="form-input">
                                            <input type="password" className="form-control" placeholder="Enter your new password"
                                                value={newPassword}
                                                onChange={handleNewPasswordChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="formblk mb20">
                                        <label className="form-label">Confirm New Password <span className="error_star">* {confirmPassError && <p className="error_star">{confirmPassError}</p>}</span></label>
                                        <div className="form-input">
                                            <input type="password" className="form-control" placeholder="Confirm your new password" id="newPassword"
                                                value={confirmPassword} onChange={handleConfirmPasswordChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="formblk mb10">
                                    </div>
                                    {error && <p className="error_star">{error}</p>}
                                    <button className="button_login" type="submit">Save</button>
                                </form>
                            </div>
                        </div>
                        <div className="copy"> @2023 Hive. All rights reserved.</div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NewPasswordCom